export const PLANS = [
	{
		key: 'plus_monthly',
		name: 'Plus',
		price: 14.99,
		interval: 'month',
		featureGroups: [
			{
				title: 'Email Automation',
				features: [
					'Auto Reach — vet, filter & auto email',
					'Up to 3 email accounts',
					'10 saved templates',
				],
			},
			{
				title: 'Maps & Routing',
				features: [
					'Custom maps with toll info',
					'Custom maps with points of interest',
				],
			},
			{
				title: 'Broker Intelligence',
				features: [
					'Broker risk assessment',
					'Broker contact vetting',
					'Factoring score analysis',
				],
			},
		],
		ctaLabel: 'Get Plus',
	},
]
